'use client';

export { default } from './Avatar';
export { default as avatarClasses } from './avatarClasses';
export * from './avatarClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Avatar/index.js
// module id = 422
// module chunks = 22